export const APPLICATION_TITLE = 'Платформа подписания';
export const APPLICATION_DESCRIPTION = 'Платформа подписания';
export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN';
export const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN';
